export default "__VITE_ASSET__D1ge2_BU__"